import { CohortShareLimitQueryDocument } from "@pathwright/graphql-client/src/generated"
import { Button, Box } from "@chakra-ui/react"
import { ChevronRightIcon } from "@pathwright/pathicons"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import { useQuery } from "@pathwright/features/src/modules/utils/apollo"
import { useShareDataContext } from "../shared/ShareDataContextProvider"
import Limit from "./Limit"
import Link from "@pathwright/ux/src/components/link/Link"
import path from "path-browserify"

const tPrefix = "share_card.add_tab"

const COHORT_SHARE_LIMIT_QUERY = CohortShareLimitQueryDocument

const useCohortShareLimit = ({ cohortId }) => {
  const query = useQuery(COHORT_SHARE_LIMIT_QUERY, {
    variables: { cohortId }
  })

  return query.data?.cohort
}

const CohortShareLimit = () => {
  const { t } = useTranslate()
  const { context, permissions } = useShareDataContext()
  const cohort = useCohortShareLimit({ cohortId: context.typeId })

  if (!cohort || permissions.add_limit === null) return null

  if (cohort.resource_license) {
    if (permissions.add_limit === 0) {
      return (
        <Limit
          text={t(`${tPrefix}.No pre-purchased seats remaining`)}
          tooltip={t(
            `${tPrefix}.Once all pre-purchased seats are filled, additional members may purchase their own seats.`
          )}
        />
      )
    } else {
      return (
        <Limit
          text={t(`${tPrefix}.{{ count }} pre-purchased seat remaining`, {
            defaultValue_plural: `${tPrefix}.{{ count }} pre-purchased seats remaining`,
            count: permissions.add_limit || 2
          })}
          tooltip={t(
            `${tPrefix}.Once all pre-purchased seats are filled, additional members may purchase their own seats.`
          )}
        />
      )
    }
  }

  return (
    <Limit
      text={t(`${tPrefix}.{{ count }} seat remaining`, {
        defaultValue_plural: `${tPrefix}.{{ count }} seats remaining`,
        count: permissions.add_limit
      })}
      tooltip={
        <Box>
          {t(
            `${tPrefix}.Once all learner seats are filled, no more learners will be able to join. Observers and staff do not count toward the seat limit.`
          )}{" "}
          {permissions.allow_manage && (
            <Link
              variant="underline"
              to={path.join(permissions.manage_url, "access/")}
              display="inline"
              colorPalette="gray"
              color="inherit"
              textDecorationColor="inherit"
            >
              {t(`${tPrefix}.Update cohort settings to change the seat limit.`)}
            </Link>
          )}
        </Box>
      }
      portal={false}
    />
  )
}

export default CohortShareLimit
